<template>
  <vs-popup
    class="scheduled-tasks-detail-popup"
    id="popup"
    title="Scheduled Task Details"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <!-- <vs-button
        @click="onClickDownload"
        button="submit"
        icon-pack="feather"
        icon="icon-download-cloud"
        color="primary"
        class="ml-auto mt-2"
        >Download</vs-button
      > -->

      <div class="p-6">
        <h2
          class="text-xl font-semibold mb-6 text-gray-800 border-b-2 border-gray-200 pb-3"
        >
          Task Information
        </h2>

        <div class="space-y-4">
          <div
            v-for="(field, index) in taskDetails.scheduled_task_schedule
              .scheduled_task_template.fields"
            :key="index"
          >
            <div class="bg-gray-50 border border-gray-200 rounded-lg p-5">
              <h4
                class="flex items-center justify-between text-base font-semibold text-gray-800 mb-4"
              >
                <span>{{ index + 1 }}. {{ field.label }}</span>
              </h4>

              <div class="w-full">
                <div v-if="field.description" class="mb-4">
                  <small
                    class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2"
                  >
                    Description
                  </small>
                  <vs-textarea :value="field.description" disabled :rows="3" />
                </div>

                <div class="mb-3">
                  <div class="w-full">
                    <div v-if="field.type == 'Boolean'" class="flex mt-2">
                        <YesNoToggle v-model="field.value" :disabled="true" />
                    </div>
                  </div>
                  <div class="w-full mb-4">
                    <vs-textarea
                      v-if="field.type == 'Text'"
                      v-model="field.value"
                      :rows="5"
                    ></vs-textarea>
                  </div>

                  <div class="w-full">
                    <flat-pickr
                      disabled
                      v-if="field.type == 'Date'"
                      class="w-full"
                      :config="flatPkrConfig"
                      v-model="field.value"
                      placeholder="Choose Date"
                    />

                    <v-select
                      disabled
                      v-if="field.type == 'Drop Down'"
                      id="type"
                      v-model="field.value"
                      :options="
                        field.options != null ? field.options.labels : []
                      "
                      :reduce="(option) => option.label"
                      placeholder="Select an option"
                    />

                    <RangeScale
                      v-if="field.type == 'Scale'"
                      v-model="field.value"
                      :min="field.options.min"
                      :max="field.options.max"
                      :labels="field.options.labels"
                      :disabled="true"
                    
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-8 pt-6 border-t-2 border-gray-200">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">
            Task Approval Log
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <span
                class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1"
              >
                Scheduled Date:
              </span>
              <span class="text-base font-medium text-gray-800">{{
                __dateTimeFormatterToDate(taskDetails.scheduled_date)
              }}</span>
            </div>

            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <span
                class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1"
              >
                Created At:
              </span>
              <span class="text-base font-medium text-gray-800">{{
                __dateTimeFormatter(taskDetails.created_at)
              }}</span>
            </div>

            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <span
                class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1"
              >
                Started At:
              </span>
              <span class="text-base font-medium text-gray-800">{{
                taskDetails.started_at
              }}</span>
            </div>

            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <span
                class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1"
              >
                Completed By:
              </span>
              <span class="text-base font-medium text-gray-800">{{
                taskDetails.completed_by.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ScheduledTasksRepository = RepositoryFactory.get("scheduled_tasks");
import flatPickr from "vue-flatpickr-component";
import RangeScale from "../../../components/range-scale/rangeScale.vue";
import ErrorMessages from "@/mixins/ErrorMessages";
import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

function initialState() {
  return {
    open: false,
    taskDetails: {},
    file: null,
  };
}

export default {
  name: "DetailViewPopUp",
  data() {
    return initialState();
  },
  components: {
    flatPickr,
    RangeScale,
    YesNoToggle
  },
  mixins: [ErrorMessages],
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        await this.fetchTaskInstance(id);
        this.open = true;
      } catch (error) {}
    },

    async fetchTaskInstance(id) {
      try {
        const { data } = await ScheduledTasksRepository.getTaskInstance(id);
        this.taskDetails = data.data;
        this.taskDetails.scheduled_task_schedule.scheduled_task_template.fields.map(
          (item, i) => {
            item.value = this.taskDetails.responses[i].value;
            return item;
          }
        );
        if (
          this.taskDetails.scheduled_task_schedule.scheduled_task_template
            .fields.length == this.taskDetails.responses.length
        ) {
          this.validForm = true;
        }
      } catch (e) {
        this.convertAndNotifyError(e);
      }
    },
    async onClickDownload() {
      try {
        this.$vs.loading();
        await ScheduledTasksRepository.downloadTaskDetails(
          this.taskDetails.id
        ).then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          this.file = URL.createObjectURL(file);
          this.$vs.loading.close();
          window.open(this.file);
        });
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style scoped>
.scheduled-tasks-detail-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}

.scheduled-tasks-detail-popup {
  .task-details {
    padding: 1rem;

    &__title {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 1.5rem;
      color: #2c3e50;
      border-bottom: 2px solid #f0f0f0;
      padding-bottom: 0.75rem;
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1.5rem;
    }
  }

  .detail-item {
    &__label {
      display: block;
      font-size: 0.875rem;
      font-weight: 600;
      color: #718096;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 0.5rem;
    }

    &__value {
      font-size: 1rem;
      color: #2d3748;
      margin: 0;
      word-break: break-word;
    }
  }

  .taskBox:first-child {
    margin-top: 20px;
  }

  .form-container {
    position: relative;
  }

  .floating-buttons {
    position: absolute !important;
    right: 0;
    top: -10px;
    display: flex;
    flex-direction: row;
  }

  .floating-buttons.sticky {
    position: fixed !important;
    top: 100px;
    right: 55px;
  }
}
</style>
